import request from "@/utils/request";
// 获取验证码
export function IUserVerify(phonenum) {
    return request({
        url: "/studentAward/sendMsg",
        method: "post",
        data: {
            mobile: phonenum
        }
    });
}
// 查询获奖结果  手机号
export function queryAwardStuByPhone(mobile, verifyCode) {
    return request({
        url: "/studentAward/queryAwardStuByPhone",
        method: "post",
        data: {
            mobile,
            verifyCode
        }
    });
}

// 查询获奖结果  邮箱
export function queryAwardStuByEmail(email, password) {
    return request({
        url: "/studentAward/queryAwardStuByEmail",
        method: "post",
        data: {
            email,
            password
        }
    });
}
// 绑定手机号
export function bindMobileAfterQueryByEmail(
    email,
    password,
    mobile,
    verifyCode
) {
    return request({
        url: "/studentAward/bindMobileAfterQueryByEmail",
        method: "post",
        data: {
            email,
            password,
            mobile,
            verifyCode
        }
    });
}
// 绑定手机号  发送验证码
export function sendMsgEmail(email, mobile) {
    return request({
        url: "/studentAward/sendMsgEmail",
        method: "post",
        data: {
            email,
            mobile
        }
    });
}
// 忘记密码 发送验证码
export function getForgetPassword(email) {
    return request({
        url: "/studentAward/getForgetPassword",
        method: "post",
        data: {
            email
        }
    });
}
// 忘记密码 编辑
export function determineAndModifyPwd(email, verifyCode, password) {
    return request({
        url: "/studentAward/determineAndModifyPwd",
        method: "post",
        data: {
            email,
            verifyCode,
            password
        }
    });
}
// 获取证书图片
export function queryAwardAfterEmail() {
    return request({
        url: "/studentAward/queryAwardAfterEmail",
        method: "post"
    });
}
// 填写地址
export function fillMailAddress(userName, linkMobile, address) {
    return request({
        url: "/studentAward/fillMailAddress",
        method: "post",
        data: {
            userName,
            linkMobile,
            address
        }
    });
}
// 判断是否关注
export function transitInterface() {
    return request({
        url: "/studentAward/transitInterface",
        method: "post"
    });
}
// 查询学校排名
export function querySchoolAwardRank(pageStart, pageSize, schoolCnName) {
    return request({
        url: "/schoolAward/querySchoolAwardRank",
        method: "post",
        data: {
            pageStart,
            pageSize,
            schoolCnName
        }
    });
}
// 查询学校信息(下拉菜单)
export function querySchoolMsg() {
    return request({
        url: "/schoolAward/querySchoolMsg",
        method: "post"
    });
}
// 发送验证码(学校名称)
export function sendVerifyCode(schoolId, mobile) {
    return request({
        url: "/schoolAward/sendVerifyCode",
        method: "post",
        data: {
            schoolId,
            mobile
        }
    });
}
// 添加学校优秀指导教师
export function addSchoolInstructor(
    schoolId,
    mobile,
    verifyCode,
    educator1,
    educator2,
    educator3
) {
    return request({
        url: "/schoolAward/addSchoolInstructor",
        method: "post",
        data: {
            schoolId,
            mobile,
            verifyCode,
            educator1,
            educator2,
            educator3
        }
    });
}
// 填写邮寄信息
export function fillMailInfo(
    schoolId,
    contactName,
    contactMobile,
    contactAddress
) {
    return request({
        url: "/schoolAward/fillMailInfo",
        method: "post",
        data: {
            schoolId,
            contactName,
            contactMobile,
            contactAddress
        }
    });
}
export function getUserGameInfo(userId, mode) {
    return request({
        url: "/api/getUserGameInfo",
        method: "post",
        data: {
            userId,
            mode
        }
    });
}

// 验证码
export function sendCode(userPhone) {
    return request({
        url: "/finalUser/sendVerifyCode",
        method: "post",
        data: {
            userPhone
        }
    });
}
export function verify(userPhone, verifyCode) {
    return request({
        url: "/finalUser/verify",
        method: "post",
        data: {
            userPhone,
            verifyCode
        }
    });
}

export function finalUserRegister(userPhone, verifyCode, idCardNo, photoUrl) {
    return request({
        url: "/finalUser/finalUserRegister",
        method: "post",
        data: {
            userPhone,
            verifyCode,
            idCardNo,
            photoUrl
        }
    });
}
export function queryUserLeaderboardNoGameId(
    pageStart,
    pageSize,
    edition,
    competeType
) {
    return request({
        url: "/user/queryUserLeaderboardNoGameId",
        method: "post",
        data: {
            pageStart,
            pageSize,
            edition,
            competeType
        }
    });
}

export function getGameList(eventCode) {
    return request({
        url: "/rank/getGameList",
        method: "get",
        params: {
            eventCode
        }
    });
}

// 移动端 无锡梁溪区 学校榜
export function schoolRankSearch(pageStart, pageSize, eventCode) {
    return request({
        url: "/rank/querySchoolLeaderboard",
        method: "get",
        params: {
            pageStart,
            pageSize,
            eventCode
        }
    });
}
// 学生榜 等级榜 两个榜单通用此接口
// 其中学生榜edition值需要传 值，而等级榜不需要edition值故传一个空值
export function userRankSearch(pageStart, pageSize, edition, gameId, batchNo) {
    return request({
        url: "/rank/queryUserLeaderboard",
        method: "get",
        params: {
            pageStart,
            pageSize,
            edition,
            gameId,
            batchNo
        }
    });
}

// 学生榜 等级榜 两个榜单通用此接口
// 其中学生榜edition值需要传 值，而等级榜不需要edition值故传一个空值
export function skillTestRank(pageStart, pageSize, gameId, batchNo) {
    return request({
        url: "/rank/getUserRank",
        // url: "/user/queryUserLeaderboard",
        method: "get",
        params: {
            pageStart,
            pageSize,
            gameId,
            batchNo
        }
    });
}


// 2021全国赛 发送验证码
export function send2021VerifyCode(account) {
    return request({
        url: "/mobile/sendMsg",
        method: "get",
        params: {
            account
        }
    });
}
/**
 *
 * @param {string} mobile 手机号
 * @param {string} authCode 验证码
 * @param {string} eventCode eventCode
 */
export function to2021signUp(mobile, authCode, eventCode) {
    return request({
        url: "/final/game/verify",
        method: "post",
        data: {
            mobile,
            authCode,
            eventCode
        }
    });
}

/**
 *
 * @param {*} eventCode eventCode
 * @param {*} mobile 手机号
 * @param {*} password 验证码
 * @param {*} type 用户账户类型
 */
export function getRegisterUserInfo(eventCode, mobile, password, type) {
    return request({
        url: "/final/game/getRegisterUserInfo",
        method: "get",
        params: {
            eventCode,
            mobile,
            password,
            type
        }
    });
}

export function getAreaALL() {
    return request({
        url: "/area/getArea",
        method: "get"
    });
}
/**
 *
 * @param {*} mobile 手机号
 * @param {*} type 用户账号类型
 */
export function getOldUserData(mobile, type) {
    return request({
        url: "/final/game/getOldUserInfo",
        method: "get",
        params: {
            mobile,
            type
        }
    });
}

/**
 *
 * @param {string} schoolName 学校名
 * @param {string} provinceCode 查询省，可空
 * @param {string} cityCode 查询市，可空
 * @param {string} countyCode 查询区县，可空
 */
export function school2021Search(
    schoolName,
    provinceCode,
    cityCode,
    countyCode
) {
    return request({
        url: "/mobile/querySchoolMsg",
        method: "get",
        params: {
            schoolName,
            provinceCode,
            cityCode,
            countyCode
        }
    });
}

/**
 *
 * @param {string} name 姓名
 * @param {string} mobile 手机号
 * @param {int} grade 年级
 * @param {int} gameId 参赛组别
 * @param {string} eventCode eventCode
 * @param {string} password 密码
 * @param {int} schoolId 学校ID
 * @param {string} schoolName 学校名
 * @param {string} provinceCode 省Code
 * @param {string} cityCode 市Code
 * @param {string} countyCode 区县Code
 * @param {string} type 用户账号类型
 * @param {string} channel 注册渠道
 */
export function submit2021userRes(
    name,
    mobile,
    grade,
    gameId,
    eventCode,
    password,
    schoolId,
    schoolName,
    provinceCode,
    cityCode,
    countyCode,
    type,
    channel
) {
    return request({
        url: "/final/game/register",
        method: "post",
        data: {
            name,
            mobile,
            grade,
            gameId,
            eventCode,
            password,
            schoolId,
            schoolName,
            provinceCode,
            cityCode,
            countyCode,
            type,
            channel
        }
    });
}

/**
 *
 * @param {string} account 帐号
 * @param {string} password 密码
 * @param {string} eventCode 活动Code
 */
export function verifyUser(account, password, eventCode) {
    return request({
        url: "/final/game/verifyUser",
        method: "post",
        data: {
            account,
            password,
            eventCode
        }
    });
}

/**
 * @description 10s刷新一次的数据接口，尽量避免，针对需要areaId的页面
 * @param {*} pageStart
 * @param {*} pageSize
 * @param {*} gameId
 * @param {*} areaId
 */
export function getUserRank_areaId(pageStart, pageSize, gameId, areaId) {
    return request({
        url: "/rank/getUserRank",
        method: "get",
        params: {
            pageStart,
            pageSize,
            gameId,
            areaId
        }
    });
}

/**
 * @description 10s刷新一次的数据接口，尽量避免，针对需要areaId的页面
 * @param {Number} pageStart
 * @param {Number} pageSize
 * @param {Number} gameId
 * @param {Number} areaId
 */
export function getUserRank_area(pageStart, pageSize, gameId, areaId) {
    return request({
        url: "game/queryRankData",
        method: "get",
        params: {
            pageStart,
            pageSize,
            gameId,
            areaId
        }
    });
}

/**
 * @description 获取该组别总人数
 * @param {Number} gameId
 */
export function queryTotalUser(gameId) {
    return request({
        url: "game/queryTotalUser",
        method: "get",
        params: {
            gameId,
        }
    });
}

/**
 *
 * @param {*} phone 手机号
 * @param {*} eventCode 活动code
 * @returns 根据url里的userPhone获取用户信息
 */
export function getUserInfoByMobile(mobile, eventCode) {
    return request({
        url: "/mobile/getUserInfoByMobile",
        method: "get",
        params: {
            mobile,
            eventCode
        }
    });
}

/**
 *
 * @param {*} firstName 姓名
 * @param {*} grade 年纪
 * @param {*} mobile 手机号
 * @param {*} password 密码
 * @param {*} eventCode 活动code
 * @param {*} gameId 参赛组别id
 * @param {*} schoolId 学校/机构Id，和schoolCnName二选一传值给后端
 * @param {*} schoolCnName 学校/机构名
 * @param {*} channel 渠道码
 * @returns 注册+报名
 */
export function toRegister(
    firstName,
    grade,
    mobile,
    password,
    eventCode,
    gameId,
    schoolId,
    schoolCnName,
    channel,
    rcmdCode
) {
    return request({
        url: "/mobile/register",
        method: "post",
        data: {
            firstName,
            grade,
            mobile,
            password,
            eventCode,
            gameId,
            schoolId,
            schoolCnName,
            channel,
            rcmdCode
        }
    });
}


// WEBPACK FOOTER //
// ./src/api/home/home.js